"use client";

import styles from "@/styles/home/recommend-list.module.scss";
import { useState, useEffect } from "react";
import { Button } from "react-vant";
import ProductItem from "@/components/global/ProductItem";
import featuredSectionApi from "@/service/modules/featuredSectionApi"
import type { ProductType } from '@/types/product';
import type { GetSectionListParams } from "@/types/contact";

export default function NotFoundLoadMore() {
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(10)
  const [pagelist, setPageList] = useState<ProductType[]>([])
  const [loading, setLoading] = useState(false)
  const [isFinsh, setIsFinsh] = useState(false)

  useEffect(() => {
    setLoading(true)
    getTopSellerList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize])

  const getTopSellerList = async () => {
    try {
      const params: GetSectionListParams = {
        page: currentPage,
        perPage: pageSize
      }
      const res = await featuredSectionApi.getSectionList("top-seller", params)
      setPageList([...pagelist, ...res.data.pageList.items])
      setLoading(false)
      setIsFinsh(res.data.pageList.items.length < pageSize)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div 
      className={styles["comp-recommend-list"]}
      style={{ paddingTop: "20px", background: "#EDEDED" }}
    >

      {
        pagelist.length > 0 && (
          <div className={styles["recommend-list"]}>
            {pagelist.map((product: ProductType) => (
              <div className={styles["recommend-item"]} key={product.productID}>
                <ProductItem product={product} />
              </div>
            ))}
          </div>
        )
      }
      
      {
        !isFinsh && pagelist.length > 0
        &&
        <Button
          type="primary"
          block
          onClick={() => {
            setCurrentPage(currentPage + 1)
          }}
          loading={loading}
          loadingText={`View more >`}
          style={{ width: "60%", margin: "16px auto" }}
        >View more {'>'}</Button>
      }
    </div>
  );
}
